module.exports = __webpack_public_path__ + "media/img/help_center/Student_Dashboard_01-b80763c0c0591e33c70725666d397170.jpg";